import React, { useMemo } from "react";
import DashboardMenu from "../../commonComponents/DashboardMenu";
import DataTable from "react-data-table-component";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import HistoryIcon from "@mui/icons-material/History";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import useStyles from "../DashboardAuction/dashAuction.style";
import buyerListAPI from "../../../api/adminAPI/buyerListAPI";
import { useState } from "react";
import moment from "moment";
import DashBuyerDetail from "../DashboardAuction/BidlogFirst/DashBuyerDetail";
import DashEventDetail from "../DashboardAuction/BidlogFirst/DashEventDetail";
import BuyerBidLog from "../DashboardAuction/BidlogFirst/BuyerBidLog";
import { getUserData, openAccessAccountTab } from "../../../common";
import { Navigate } from "react-router-dom";

import lodash from "lodash";
import { FaRegFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import buyerDeleteAPI from "../../../api/adminAPI/buyerDeleteAPI";
import buyerUpdateStatusAPI from "../../../api/adminAPI/buyerUpdateStatusAPI";
import updateBuyerAPI from "../../../api/adminAPI/updateBuyerAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import accessBuyerAccountAPI from "../../../api/adminAPI/accessBuyerAccountAPI";
import LoginIcon from "@mui/icons-material/Login";
import buyerHistoryAPI from "../../../api/adminAPI/buyerHistoryAPI";
import {
  DATE_DISPLAY,
  DATE_TIME_DISPLAY,
  dateSortValue,
} from "../../../common/dateTime";

const EMPTY_FILTERS = {
  search: "",
  auctionType: "",
  status: "",
  bidActivity: "",
  registeredFrom: "",
  registeredTo: "",
  state: "",
  city: "",
};

// FA = forward auctions, RA = reverse auctions the bidder is in
const AUCTION_TYPE_FILTERS = {
  FORWARD: (buyer) => buyer.forwardEvents > 0,
  REVERSE: (buyer) => buyer.reverseEvents > 0,
  BOTH: (buyer) => buyer.forwardEvents > 0 && buyer.reverseEvents > 0,
  NONE: (buyer) => buyer.forwardEvents + buyer.reverseEvents === 0,
};

const BID_ACTIVITY_FILTERS = {
  HAS_BID: (buyer) => buyer.totalBidedItems > 0,
  NEVER_BID: (buyer) => !buyer.totalBidedItems,
  HAS_WON: (buyer) => buyer.h1RanksCount > 0,
};

const formatDate = (value) => (value ? moment(value).format(DATE_DISPLAY) : "");

// the Excel file has exactly the rows on screen: the filters apply
const EXPORT_FIELDS = [
  ["Sr. No.", (buyer) => buyer.id],
  ["User Name", (buyer) => buyer.userName],
  ["Email", (buyer) => buyer.email],
  ["Mobile Number", (buyer) => buyer.contactNumber],
  ["Alt. Mobile Number", (buyer) => buyer.alternateContactNumber || ""],
  ["City", (buyer) => buyer.city || ""],
  ["State", (buyer) => buyer.state || ""],
  ["Status", (buyer) => buyer.status],
  ["FA", (buyer) => buyer.forwardEvents],
  ["RA", (buyer) => buyer.reverseEvents],
  ["Lots", (buyer) => buyer.totalItems],
  ["Allotted Lots", (buyer) => buyer.allotedItems],
  ["Bidded Lots", (buyer) => buyer.totalBidedItems],
  ["H1/L1", (buyer) => buyer.h1RanksCount],
  ["H2/L2", (buyer) => buyer.h2RanksCount],
  ["Others", (buyer) => buyer.h3RanksCount],
  ["Registration Date", (buyer) => formatDate(buyer.registrationDate)],
];

const FIELD_LABELS = {
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  contactNumber: "Mobile Number",
  alternateContactNumber: "Alt. Mobile Number",
  status: "Status",
};

// what one history row says, line by line
const describeHistoryEntry = ({ eventType, metadata }) => {
  const auction = [metadata?.eventNumber, metadata?.auctionTitle]
    .filter(Boolean)
    .join(" - ");
  switch (eventType) {
    case "BUYER_DELETED":
      return ["Bidder deleted"];
    case "BUYER_ADDED_TO_AUCTION":
      return [`Added to auction ${auction}`];
    case "BUYER_REMOVED_FROM_AUCTION":
      return [`Removed from auction ${auction}`];
    default:
      return Object.entries(metadata?.changes ?? {}).map(
        ([field, { from, to }]) =>
          `${FIELD_LABELS[field] ?? field}: ${from ?? "-"} → ${to ?? "-"}`
      );
  }
};

const ROLE_LABELS = { ADMIN: "Admin", SELLER: "Organiser" };

const uniqueSorted = (values) =>
  lodash.sortBy(lodash.uniq(values.filter(Boolean)));

function DashBuyer() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [changeView, SetChangeView] = useState(false);
  const [buyerEventId, SetBuyerEventId] = useState("");
  const [buyerEventItemId, SetBuyerEvenItemtId] = useState("");
  const [buyerId, SetBuyerId] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState(null);

  const userData = getUserData() ?? {};
  // only an admin can change a bidder or see the change history; an
  // organiser sees the current details only
  const isAdmin = userData.role === "ADMIN";

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedBuyer(row);
    SetBuyerId(row.buyerId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedBuyer(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [tableBuyers, setTableBuyers] = useState([]);

  const buyerList = async () => {
    try {
      const { data } = await buyerListAPI();

      if (data) {
        let id = 1;
        const buyersData = data.map((buyer) => {
          return {
            id: id++,
            userName: `${buyer.firstName} ${buyer.lastName}`,
            firstName: buyer.firstName,
            lastName: buyer.lastName,
            email: buyer.email,
            contactNumber: buyer.contactNumber,
            alternateContactNumber: buyer.alternateContactNumber,
            buyerId: buyer.userId,
            h1RanksCount: buyer.h1RanksCount,
            h2RanksCount: buyer.h2RanksCount,
            h3RanksCount: buyer.h3RanksCount,
            totalEvents: buyer.totalEvents,
            forwardEvents: buyer.forwardEvents ?? 0,
            reverseEvents: buyer.reverseEvents ?? 0,
            city: buyer.city,
            state: buyer.state,
            totalBidedItems: buyer.totalBidedItems,
            totalItems: buyer.totalItems,
            allotedItems: buyer.allotedItems,
            registrationDate: buyer.createdAt,
            status: buyer.status,
          };
        });

        setTableBuyers(buyersData);
      } else throw new Error(data);
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    buyerList();
    return () => {
      return false;
    };
  }, []);

  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const setFilter = (name) => (event) =>
    setFilters((prev) => ({ ...prev, [name]: event.target.value }));
  const hasFilters = !lodash.isEqual(filters, EMPTY_FILTERS);

  const stateOptions = useMemo(
    () => uniqueSorted(tableBuyers.map((buyer) => buyer.state)),
    [tableBuyers]
  );
  // cities of the chosen state only, once a state is picked
  const cityOptions = useMemo(
    () =>
      uniqueSorted(
        tableBuyers
          .filter((buyer) => !filters.state || buyer.state === filters.state)
          .map((buyer) => buyer.city)
      ),
    [tableBuyers, filters.state]
  );

  const filteredBuyers = useMemo(() => {
    const search = filters.search.trim().toLowerCase();
    const from = filters.registeredFrom
      ? moment(filters.registeredFrom).startOf("day")
      : null;
    const to = filters.registeredTo
      ? moment(filters.registeredTo).endOf("day")
      : null;

    return tableBuyers.filter((buyer) => {
      if (filters.status && buyer.status !== filters.status) return false;
      if (
        filters.auctionType &&
        !AUCTION_TYPE_FILTERS[filters.auctionType](buyer)
      ) {
        return false;
      }
      if (
        filters.bidActivity &&
        !BID_ACTIVITY_FILTERS[filters.bidActivity](buyer)
      ) {
        return false;
      }
      if (filters.state && buyer.state !== filters.state) return false;
      if (filters.city && buyer.city !== filters.city) return false;
      const registered = moment(buyer.registrationDate);
      if (from && registered.isBefore(from)) return false;
      if (to && registered.isAfter(to)) return false;
      if (!search) return true;
      return [buyer.userName, buyer.email, buyer.contactNumber].some((value) =>
        String(value ?? "").toLowerCase().includes(search)
      );
    });
  }, [tableBuyers, filters]);

  // change history of one bidder (admin only): { buyer, entries, loading }
  const [history, setHistory] = useState(null);

  const handleOpenHistory = async () => {
    if (!selectedBuyer) return;
    const buyer = selectedBuyer;
    setAnchorEl(null);
    setHistory({ buyer, entries: [], loading: true });
    try {
      const { data } = await buyerHistoryAPI(buyer.buyerId);
      setHistory({ buyer, entries: data, loading: false });
    } catch (error) {
      setHistory(null);
      toast(error.response?.data?.error || "Failed to load history");
    }
  };

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editForm, setEditForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    alternateContactNumber: "",
  });

  const handleOpenEdit = () => {
    if (!selectedBuyer) return;
    setEditForm({
      firstName: selectedBuyer.firstName || "",
      lastName: selectedBuyer.lastName || "",
      email: selectedBuyer.email || "",
      contactNumber: selectedBuyer.contactNumber || "",
      alternateContactNumber: selectedBuyer.alternateContactNumber || "",
    });
    setOpenEditDialog(true);
    setAnchorEl(null);
  };

  const handleUpdateBuyer = async () => {
    try {
      const payload = {
        firstName: editForm.firstName,
        lastName: editForm.lastName,
        email: editForm.email,
        contactNumber: editForm.contactNumber,
        alternateContactNumber: editForm.alternateContactNumber || null,
      };
      const { data } = await updateBuyerAPI(payload, buyerId);
      // saved, but the mobile number is also used by another account
      if (data?.warning) toast.warning(data.warning);
      else toast("Bidder updated successfully!");
      setOpenEditDialog(false);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to update bidder");
    }
  };

  const handleDeleteBuyer = async () => {
    try {
      await buyerDeleteAPI(buyerId);
      toast("Bidder deleted successfully!");
      setOpenDeleteDialog(false);
      setAnchorEl(null);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to delete bidder");
    }
  };

  const handleUpdateStatus = async () => {
    try {
      const payload = {
        status: selectedBuyer?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      await buyerUpdateStatusAPI(payload, buyerId);
      toast("Bidder status updated successfully!");
      setOpenStatusDialog(false);
      setAnchorEl(null);
      await buyerList();
    } catch (error) {
      toast(error.response?.data?.error || "Failed to update status");
    }
  };

  const handleAccessBuyerAccount = async () => {
    if (!selectedBuyer?.buyerId) return;

    try {
      const { data } = await accessBuyerAccountAPI(selectedBuyer.buyerId);
      const opened = openAccessAccountTab({
        token: data.token,
        userData: data.user,
      });

      if (!opened) {
        return toast("Please allow popups to open the support access tab");
      }

      toast(`Support access enabled for ${selectedBuyer.userName}`);
      setAnchorEl(null);
    } catch (error) {
      toast(error.response?.data?.error || "Failed to access bidder account");
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number",
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Alt. Mobile Number",
      selector: (row) => row.alternateContactNumber || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "City",
      selector: (row) => row.city || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "State",
      selector: (row) => row.state || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      width: "130px",
    },
    {
      name: <Tooltip title="Forward auctions"><span>FA</span></Tooltip>,
      selector: (row) => row.forwardEvents,
      sortable: true,
    },
    {
      name: <Tooltip title="Reverse auctions"><span>RA</span></Tooltip>,
      selector: (row) => row.reverseEvents,
      sortable: true,
    },
    {
      name: "Lots",
      selector: (row) => row.totalItems,
      sortable: true,
    },
    {
      name: "Allotted Lots",
      selector: (row) => row.allotedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "Bidded Lots",
      selector: (row) => row.totalBidedItems,
      sortable: true,
      width: "130px",
    },
    {
      name: "H1/L1",
      selector: (row) => row.h1RanksCount,
      sortable: true,
    },
    {
      name: "H2/L2",
      selector: (row) => row.h2RanksCount,
      sortable: true,
    },
    {
      name: "Others",
      selector: (row) => row.h3RanksCount,
      sortable: true,
    },
    {
      name: "Registration Date",
      selector: (row) => dateSortValue(row.registrationDate),
      cell: (row) => moment(row.registrationDate).format(DATE_DISPLAY),
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <div>
          <Button
            aria-describedby={id}
            variant="contained"
            onClick={(event) => handleClick(event, row)}
          >
            <MoreVertIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2, display: "grid" }}>
              <span
                className={classes.viewBtn}
                onClick={() => {
                  SetChangeView("DashBuyerDetail");
                  SetBuyerId(buyerId);
                  setAnchorEl(null);
                }}
              >
                <RemoveRedEyeIcon
                  style={{ color: "#2D55EB", paddingRight: "5px" }}
                />
                View
              </span>
              {isAdmin && (
                <span className={classes.viewBtn} onClick={handleOpenEdit}>
                  <EditIcon style={{ color: "#2D55EB", paddingRight: "5px" }} />
                  Edit
                </span>
              )}
              {isAdmin && (
                <span className={classes.viewBtn} onClick={handleOpenHistory}>
                  <HistoryIcon
                    style={{ color: "#2D55EB", paddingRight: "5px" }}
                  />
                  History
                </span>
              )}
              {isAdmin && (
                <span
                  className={classes.viewBtn}
                  onClick={handleAccessBuyerAccount}
                >
                  <LoginIcon
                    style={{ color: "#2D55EB", paddingRight: "5px" }}
                  />
                  Access Account
                </span>
              )}
              {isAdmin && (
                <span
                  className={classes.viewBtn}
                  onClick={() => {
                    setOpenDeleteDialog(true);
                    setAnchorEl(null);
                  }}
                >
                  <DeleteIcon style={{ color: "red", paddingRight: "5px" }} />
                  Delete
                </span>
              )}
              {!isAdmin ? null : selectedBuyer?.status === "ACTIVE" ? (
                <span
                  className={classes.viewBtn}
                  onClick={() => {
                    setOpenStatusDialog(true);
                    setAnchorEl(null);
                  }}
                >
                  <CancelIcon style={{ color: "red", paddingRight: "5px" }} />
                  Inactive
                </span>
              ) : (
                <span
                  className={classes.viewBtn}
                  onClick={() => {
                    setOpenStatusDialog(true);
                    setAnchorEl(null);
                  }}
                >
                  <CheckIcon style={{ color: "green", paddingRight: "5px" }} />
                  Active
                </span>
              )}
            </Typography>
          </Popover>
        </div>
      ),
    },
  ];

  const exportToXLSX = (buyers) => {
    const rows = buyers.map((buyer) =>
      EXPORT_FIELDS.map(([, value]) => value(buyer))
    );
    const worksheet = XLSX.utils.aoa_to_sheet([
      EXPORT_FIELDS.map(([header]) => header),
      ...rows,
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bidders");
    XLSX.writeFile(workbook, `bidders-${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  const renderComponent = () => {
    switch (changeView) {
      case "DashBuyerDetail":
        return (
          <DashBuyerDetail
            DashEventDetail={(buyerId, buyerEventId) => {
              SetChangeView("DashEventDetail");
              SetBuyerEventId(buyerEventId);
            }}
            BidlogFirst={() => {
              SetChangeView("AuctionBid");
            }}
            buyerId={buyerId}
          />
        );
      case "DashEventDetail":
        return (
          <DashEventDetail
            BuyerBidLog={(eventItemId) => {
              SetChangeView("BuyerBidLog");
              SetBuyerEvenItemtId(eventItemId);
            }}
            DashBuyerDetail={(buyerId) => {
              SetChangeView("DashBuyerDetail");
              SetBuyerId(buyerId);
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
          />
        );
      case "BuyerBidLog":
        return (
          <BuyerBidLog
            DashEventDetail={() => {
              SetChangeView("DashEventDetail");
            }}
            buyerId={buyerId}
            buyerEventId={buyerEventId}
            buyerEventItemId={buyerEventItemId}
          />
        );
      default:
        return (
          <div className="AuctionTable">
            {userData.role != "BUYER" ? (
              <>
                <h3>Bidder List</h3>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <TextField
                    size="small"
                    label="Search name, email, mobile"
                    sx={{ minWidth: 240 }}
                    value={filters.search}
                    onChange={setFilter("search")}
                  />
                  <TextField
                    select
                    size="small"
                    label="Auction type"
                    sx={{ minWidth: 170 }}
                    value={filters.auctionType}
                    onChange={setFilter("auctionType")}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="FORWARD">Forward (FA)</MenuItem>
                    <MenuItem value="REVERSE">Reverse (RA)</MenuItem>
                    <MenuItem value="BOTH">Both FA and RA</MenuItem>
                    <MenuItem value="NONE">Never participated</MenuItem>
                  </TextField>
                  <TextField
                    select
                    size="small"
                    label="Status"
                    sx={{ minWidth: 130 }}
                    value={filters.status}
                    onChange={setFilter("status")}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="ACTIVE">Active</MenuItem>
                    <MenuItem value="INACTIVE">Inactive</MenuItem>
                  </TextField>
                  <TextField
                    select
                    size="small"
                    label="Bid activity"
                    sx={{ minWidth: 160 }}
                    value={filters.bidActivity}
                    onChange={setFilter("bidActivity")}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="HAS_BID">Has bid</MenuItem>
                    <MenuItem value="NEVER_BID">Never bid</MenuItem>
                    <MenuItem value="HAS_WON">Has H1/L1</MenuItem>
                  </TextField>
                  <TextField
                    select
                    size="small"
                    label="State"
                    sx={{ minWidth: 150 }}
                    value={filters.state}
                    onChange={(event) =>
                      setFilters((prev) => ({
                        ...prev,
                        state: event.target.value,
                        city: "",
                      }))
                    }
                  >
                    <MenuItem value="">All</MenuItem>
                    {stateOptions.map((state) => (
                      <MenuItem key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    size="small"
                    label="City"
                    sx={{ minWidth: 150 }}
                    value={filters.city}
                    onChange={setFilter("city")}
                  >
                    <MenuItem value="">All</MenuItem>
                    {cityOptions.map((city) => (
                      <MenuItem key={city} value={city}>
                        {city}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    type="date"
                    size="small"
                    label="Registered from"
                    InputLabelProps={{ shrink: true }}
                    value={filters.registeredFrom}
                    onChange={setFilter("registeredFrom")}
                  />
                  <TextField
                    type="date"
                    size="small"
                    label="Registered to"
                    InputLabelProps={{ shrink: true }}
                    value={filters.registeredTo}
                    onChange={setFilter("registeredTo")}
                  />
                  {hasFilters && (
                    <Button onClick={() => setFilters(EMPTY_FILTERS)}>
                      Clear filters
                    </Button>
                  )}
                  <Box sx={{ flexGrow: 1 }} />
                  <Typography variant="body2" sx={{ color: "#6b7280" }}>
                    Showing {filteredBuyers.length} of {tableBuyers.length}{" "}
                    bidders
                  </Typography>
                  <Tooltip title="Export the bidders shown to Excel">
                    <Button onClick={() => exportToXLSX(filteredBuyers)}>
                      <FaRegFileExcel
                        style={{
                          fontSize: "30px",
                          color: "#04aa18",
                          paddingTop: "4px",
                        }}
                      />
                    </Button>
                  </Tooltip>
                </Box>
                <DataTable
                  columns={columns}
                  data={filteredBuyers}
                  pagination
                  highlightOnHover
                  className="DataTable"
                  noDataComponent="No bidders match these filters"
                />
              </>
            ) : (
              <Navigate to={{ pathname: "/dashboard" }} />
            )}

            <Dialog
              open={openDeleteDialog}
              onClose={() => setOpenDeleteDialog(false)}
            >
              <DialogTitle>{"Delete Bidder ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete{" "}
                  <b>{selectedBuyer?.userName ?? "this bidder"}</b>?
                  {selectedBuyer &&
                    ` They are in ${
                      selectedBuyer.forwardEvents + selectedBuyer.reverseEvents
                    } auction(s) (FA ${selectedBuyer.forwardEvents}, RA ${
                      selectedBuyer.reverseEvents
                    }).`}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
                <Button onClick={handleDeleteBuyer} autoFocus>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openStatusDialog}
              onClose={() => setOpenStatusDialog(false)}
            >
              <DialogTitle>{"Update Bidder Status ?"}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to change status of Bidder ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenStatusDialog(false)}>Cancel</Button>
                <Button onClick={handleUpdateStatus} autoFocus>
                  Update
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={Boolean(history)}
              onClose={() => setHistory(null)}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>
                Change history - {history?.buyer.userName}
              </DialogTitle>
              <DialogContent dividers>
                {history?.loading ? (
                  <Typography>Loading...</Typography>
                ) : !history?.entries.length ? (
                  <Typography>
                    No changes recorded yet. Only changes made after this
                    update are recorded.
                  </Typography>
                ) : (
                  history.entries.map((entry) => (
                    <Box
                      key={entry.activityLogId}
                      sx={{ py: 1, borderBottom: "1px solid #e5e7eb" }}
                    >
                      <Typography variant="body2" sx={{ color: "#6b7280" }}>
                        {moment(entry.createdAt).format(DATE_TIME_DISPLAY)} -{" "}
                        {entry.changedBy ?? "Unknown"}
                        {entry.role && ` (${ROLE_LABELS[entry.role] ?? entry.role})`}
                      </Typography>
                      {describeHistoryEntry(entry).map((line) => (
                        <Typography key={line}>{line}</Typography>
                      ))}
                    </Box>
                  ))
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setHistory(null)}>Close</Button>
              </DialogActions>
            </Dialog>

            <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
              <DialogTitle>Edit Bidder</DialogTitle>
              <DialogContent sx={{ display: "grid", gap: 2, minWidth: 420 }}>
                <TextField
                  label="First Name"
                  value={editForm.firstName}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, firstName: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Last Name"
                  value={editForm.lastName}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, lastName: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Email"
                  value={editForm.email}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, email: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Mobile Number"
                  value={editForm.contactNumber}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, contactNumber: e.target.value }))
                  }
                  fullWidth
                />
                <TextField
                  label="Alt. Mobile Number"
                  value={editForm.alternateContactNumber}
                  onChange={(e) =>
                    setEditForm((prev) => ({
                      ...prev,
                      alternateContactNumber: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
                <Button onClick={handleUpdateBuyer}>Save</Button>
              </DialogActions>
            </Dialog>
          </div>
        );
    }
  };

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>{renderComponent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBuyer;
